export default "__VITE_ASSET__1872bfdf__"